<template>
  <div class="multiEnd">
    <div class="container">
      <ClientBox :background="'#E6E6E6'">
        <div class="cards">
          <ul>
            <li v-for="(item , index) in cards" :key="index">
            <span>{{item.name}}
              <!-- <img src="@/assets/images/logo.png" alt="LogoEn" /> -->
            </span>
              <h3>{{numeral(item.value).format('0,0.00')}}</h3>
              <p>{{item.account}}
                <!-- <img src="@/assets/images/Client/card-logo.png" alt="LogoEn" /> -->
              </p>
            </li>
          </ul>
        </div>

        <div class="midden">
          <div ref="pie" class="pie"></div>
          <div class="rate">
            <img src="@/assets/images/Client/lines.png" alt="lines"/>
            <ul>
              <li v-for="(item , index) in days" :key="index">{{item}}</li>
            </ul>
          </div>
        </div>

        <div class="bottom">
          <div ref='bar' class="bar"></div>
        </div>
      </ClientBox>

      <!-- <img src="@/assets/images/Client/card.png"> -->

      <div class="phoneBox">
        <div class="phone">
          <div class="bangs">
            <div></div>
            <div></div>
          </div>
          <div class="view">
            <ul class="cards" :style="`left: ${-154 * current + 8}px;`">
              <li v-for="(item , index) in cards" :key="index" :class="current === index ? 'current' : ''">
              <span>{{item.name}}
                <!-- <img src="@/assets/images/logo.png" alt="LogoEn" /> -->
              </span>
                <h3>{{numeral(item.value).format('0,0.00')}}</h3>
                <p>{{item.account}}
                  <!-- <img src="@/assets/images/Client/card-logo.png" alt="LogoEn" /> -->
                </p>
              </li>
            </ul>

            <div class="nav">
              <div v-for="(item , index) in cards" :key="index" :class="current === index ? 'current' : ''"></div>
            </div>

            <div class="contact">
              <ul class="action">
                <li>
                  <img src="@/assets/images/Client/contact1.png" alt="action" />
                </li>
                <li>
                  <img src="@/assets/images/Client/contact2.png" alt="action" />
                </li>
                <li>
                  <img src="@/assets/images/Client/contact3.png" alt="action" />
                </li>
                <li>
                  <img src="@/assets/images/Client/contact4.png" alt="action" />
                </li>
              </ul>

              <transition-group class="person" tag="ul" name="list">
                <li v-for="(item , index) in curContact" :key="item + index">
                  <img :src="require('@/assets/images/Client/'+item+'.png')">
                  <div>
                    <div></div>
                    <div></div>
                  </div>
                </li>
              </transition-group>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClientBox from '../ClientBox';
  import numeral from 'numeral';
  import base from '../base'
  export default {
    extends: base,
    name: "MultiEndAnimation",
    components: {
      ClientBox
    },
    data() {
      return {
        numeral,
        current: 1,
        cards : [
          {
            name: 'HKD',
            value: 8763.4,
            account: '0748',
          },
          {
            name: 'CNY',
            value: 7263.9,
            account: '0314',
          },
          {
            name: 'USD',
            value: 6763.7,
            account: '0405',
          },
          {
            name: 'JPN',
            value: 1263.9,
            account: '0224',
          },
        ],
        days: ['12-01','12-03','12-06','12-09','12-12','12-15','12-18'],
        //饼图相关
        pieChart: null,
        pieOption: {
          animation: false,
          color:['#515DE1', '#20BD74' , '#00CCFF' , '#9BB5FF'],
          series: [{
            type: 'pie',
            radius: ['50%', '70%'],
            label: {
              show: false,
              position: 'center',
              formatter: '{b}\n\n{c}',
              color: '#A2A8AC'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '8',
              }
            },
            labelLine: { show: false },
            data: [],
          }]
        },
        //柱状图
        barColor: ['#20BD74' , '#515DE1', '#00CCFF'],
        barChart: null,
        barOption : {
          animation: false,
          grid: { left: 5, top: 30 , right: 5, bottom: 25 },
          xAxis: {
            data: [1,2,3,4,5,6,7,8,9],
          },
          yAxis: {
            show: false,
          },
          series: [{
            data: [160, 200, 120, 160, 140, 190, 140, 180, 110],
            barWidth: 12,//柱子的宽度
            type: 'bar',
            itemStyle: {
              barBorderRadius: [16,16,0,0],
              color: (params) => {
                return this.barColor[(params.dataIndex+1)%3];
              },
            },
          }]
        },
        curContact: [],
        contact: [
          ['avatar5','avatar6'],
          ['avatar1','avatar2','avatar3','avatar4'],
          ['avatar3','avatar5','avatar6','avatar2'],
          ['avatar3','avatar6'],
        ],
      }
    },
    mounted() {
      this.drawPie();
      this.drawBar();

      this.dir = -1;
      this.showPerson();
      this.setInterval(() => {
        this.showPerson();
      }, 5000);

    },
    methods : {
      drawPie() {
        this.pieOption.series[0].data = this.cards;
        // 基于准备好的dom，初始化echarts实例
        this.pieChart = this.$echarts.init(this.$refs.pie);
        // 绘制图表
        this.pieChart.setOption(this.pieOption);
        this.pieChart.dispatchAction({
          type: 'highlight',
          name: this.cards[1].name,
        })
      },
      drawBar() {
        // 基于准备好的dom，初始化echarts实例
        this.barChart = this.$echarts.init(this.$refs.bar);
        // 绘制图表
        this.barChart.setOption(this.barOption);
      },
      showPerson() {
        this.dir *= -1;
        this.current += this.dir;
        //移除
        for(let i = 0 ; i < this.curContact.length; i++){
          this.curContact.splice(i,1);
          i--;
        }
        //填充新数据
        this.setTimeOut(() => {
          for(let i = 0 ; i < this.contact[this.current].length; i++){
            this.setTimeOut(() => {
              this.curContact.push(this.contact[this.current][i]);
            },50*i);
          }
        },500);
      }
    }
  }
</script>

<style lang="less" scoped>
.multiEnd {
  user-select: none;
  .container {
    display: flex;
    position: relative;

    .right {
      .cards {
        flex-grow: 1;
        background: #FFF;
        border-radius: 8px;
        padding: 0 20px 0 0;
        & > ul {
          list-style: none;
          padding: 20px 0 20px 20px;
          display: flex;
          overflow: hidden;
          & > li {
            flex-shrink: 0;
            width: 150px;
            background: #255CC5;
            border-radius: 5px;
            margin-right: 20px;
            padding: 8px;
            color: #FFF;

            & > span {
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 12px;
              line-height: 12px;
              & > img {
                width: 72px;
              }
            }
            & > h3 {
              font-size: 14px;
              color: #FFF;
              margin-top: 9px;
              line-height: 17px;
            }
            & > p {
              position: relative;
              margin-top: 30px;
              font-size: 12px;
              display: flex;
              align-items: center;
              line-height: 16px;

              & > img {
                position: absolute;
                width: 22px;
                top: 1px;
                right: 0;
              }

              &:before {
                content: '....';
                line-height: 8px;
                margin-top: -8px;
                margin-right: 10px;
              }
            }
            &:first-child {
              box-shadow: 0px 10px 20px -5px rgba(22, 20, 34, 0.5);
            }
          }
        }
      }

      .midden {
        display: flex;
        position: relative;
        margin-top: 16px;
        .pie {
          width: 171px;
          height: 151px;
          background: #FFFFFF;
          border-radius: 8px;
        }
        .rate {
          position: relative;
          margin-left: 17px;
          width: 278px;
          height: 151px;
          background: #FFFFFF;
          border-radius: 8px;
          overflow: hidden;
          & > img {
            position: absolute;
            left: -80px;
            top: -20px;
            width: 500px;
          }
          & > ul {
            position: absolute;
            bottom: 10px;
            list-style: none;
            display: flex;
            padding: 0;
            & > li {
              padding: 0 4px;
              font-size: 2px;
              font-weight: 400;
              color: #A2A8AC;
            }
          }
        }
      }

      .bottom {
        position: relative;
        margin-top: 16px;
        background: #FFFFFF;
        padding: 0 12px;
        border-radius: 8px;
        .bar {
          height: 150px;
        }
      }
    }

    .phoneBox {
      position: absolute;
      padding: 6px;
      background: #FFFFFF;
      box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
      border-radius: 25px;
      left: -81px;
      bottom: -65px;

      width: 190px;
      height: 385px;

      .phone {
        position: relative;
        border-radius: 20px;
        overflow: hidden;
        background: #E7E8F0;

        .bangs {
          position: absolute;
          background: #FFF;
          width: 91px;
          height: 28px;
          border-radius: 15px;
          top: -14px;
          left: 43px;

          & > div {
            position: absolute;
            background: #F5F8FB;
            left: 31px;
            bottom: 6px;
            width: 30px;
            height: 5px;
            border-radius: 3px;
            border: 1px solid #E9EEF3;

            &:last-child {
              left: 71px;
              width: 5px;
              height: 5px;
            }
          }
        }

        .view{
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          padding: 5px;
          width: 178px;

          .cards {
            position: absolute;
            top: 0;
            list-style: none;
            padding: 25px 4px 15px 4px;
            display: flex;
            transition: all 0.5s;

            & > li {
              flex-shrink: 0;
              width: 158px;
              background: #255CC5;
              border-radius: 5px;
              margin: 0 -2px;
              padding: 8px;
              color: #FFF;
              transform: scale(0.9);
              transition: all 0.5s;

              & > span {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                line-height: 12px;
                & > img {
                  width: 72px;
                }
              }
              & > h3 {
                font-size: 14px;
                color: #FFF;
                margin-top: 6px;
                line-height: 17px;
              }
              & > p {
                position: relative;
                margin-top: 32px;
                display: flex;
                align-items: center;
                font-size: 9px;
                line-height: 16px;

                & > img {
                  position: absolute;
                  right: 0px;
                  top: 1px;
                  width: 22px;
                }
                &:before {
                  content: '....';
                  line-height: 8px;
                  margin-top: -8px;
                  margin-right: 10px;
                }
              }
            }
            .current {
              transform: scale(1);
              box-shadow: 0px 10px 20px -5px rgba(22, 20, 34, 0.2);
            }
          }

          .nav {
            display: flex;
            justify-content: center;
            margin-top: 133px;
            & > div {
              width: 4px;
              height: 4px;
              background: #FFFFFF;
              margin: 0 3px;
              border-radius: 4px;
            }
            .current {
              background: #0070FF;
            }
          }

          .contact {
            margin-top: 5px;
            height: 221px;
            background: #FFFFFF;
            border-radius: 8px 8px 16px 16px;
            padding: 10px;

            .action {
              list-style: none;
              display: flex;
              justify-content: space-between;

              & > li {
                & > img {
                  width: 28px;
                }
              }
            }

            .person {
              list-style: none;
              margin-top: 20px;
              & > li {
                display: flex;
                margin-bottom: 12px;
                transition: all 0.4s;
                & > img {
                  height: 26px;
                }
                & > div {
                  display: flex;
                  flex: 1;
                  flex-direction: column;
                  padding: 5px 0 0 8px;
                  & > div {
                    height: 5px;
                    background: #EDF1F9;
                    border-radius: 4px;
                    &:last-child {
                      margin-top: 6px;
                      width: 62px;
                    }
                  }
                }
              }
            }

          }
        }
      }
    }

    & > img {
      position: absolute;
      left: 84px;
      bottom: -50px;
      width: 213px;
    }
  }

  .list-leave-active , .list-leave-to {
    transform: translateX(-100%);
    opacity: 0;
  }
  .list-enter {
    transform: translateY(200%);
    opacity: 0;
  }
}
</style>
